export enum ButtonType {
  button = 'button',
  submit = 'submit',
  reset = 'reset',
}

export enum ButtonSize {
  large = 'large',
  small = 'small',
}

export enum ButtonStyle {
  primary = 'primary',
  secondary = 'secondary',
  ghost = 'ghost',
}
